import { AbstractControl, Validators } from '@angular/forms';

export function requiredIfValidator(predicate: () => boolean) {
  return (formControl: AbstractControl) => {
    if (!formControl.parent) {
      return null;
    }
    if (predicate()) {
      return Validators.required(formControl);
    }
    return null;
  };
}
